import { getAxiosInstance } from '@utils/request';
import { RouteMenu } from '@project/store/Controller';

export class APIGeolocate {
  readonly url =
    'https://suggestions.dadata.ru/suggestions/api/4_1/rs/geolocate/address';
  readonly token = process.env.DADATA_KEY;

  async back(lat: number, lon: number) {
    const query = {
      lat: lat,
      lon: lon,
      radius_meters: 50,
    };
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Token ' + this.token,
      },
    };

    const response = await getAxiosInstance().post(
      `${this.url}/`,
      query,
      options,
    );

    return response;
  }

  async get(point: string, vehicleType: RouteMenu) {
    const host = `${process.env.GRAPHHOPPER_HOST}/route?`;
    const vehicle = `profile=${vehicleType}`;
    const locale = '&locale=ru-Ru';
    const points_encoded = '&points_encoded=false';
    const key = `&key=${process.env.GRAPHHOPPER_KEY}`;

    const response = await getAxiosInstance().get(
      `${host}${vehicle}${locale}${points_encoded}${key}${point}`,
    );

    return response;
  }
}
